function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_CtaL4EVf0qn599cNbDPd7AmAV5SIR1fu"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1000,
  height: 1000
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_CtaL4EVf0qn599cNbDPd7AmAV5SIR1fu)"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 0 1000 L 1000 1000 L 1000 0 L 0 0 L 0 1000 Z ",
  fill: "rgb(255,87,87)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 0 527.289 L 0 1000 L 236.031 1000 L 514.46 792.648 L 446.584 701.505 L 486.851 701.505 L 486.851 526.953 L 527.903 496.381 L 486.851 441.258 L 486.851 311.375 L 390.125 311.375 L 354.379 263.375 L 0 527.289 Z ",
  fill: "rgb(0,194,203)"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_IwbkgFqe8SVx3jgHOcZ7qJmwEF38ws9n"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 0 1000 L 1000 1000 L 1000 0 L 0 0 L 0 1000 Z ",
  fill: "rgb(255,255,255)"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_IwbkgFqe8SVx3jgHOcZ7qJmwEF38ws9n)"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 461.017 335.412 L 390.183 776.762 C 390.183 776.762 386.913 791.474 397.267 792.563 C 407.619 793.653 510.056 792.563 510.056 792.563 C 510.056 792.563 517.684 793.108 520.408 782.211 C 523.133 771.313 621.21 205.731 621.21 205.731 C 621.21 205.731 625.024 190.475 611.948 189.386 C 598.871 188.296 511.69 185.026 511.69 185.026 C 511.69 185.026 506.836 185.026 500 187.751 C 493.164 190.475 363.484 257.495 363.484 257.495 C 363.484 257.495 350.952 261.854 352.041 271.662 C 353.131 281.47 370.022 365.926 370.022 365.926 C 370.022 365.926 373.292 376.823 387.458 370.284 C 401.625 363.746 461.017 335.412 461.017 335.412 Z ",
  fill: "rgb(255,255,255)"
})));

function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 1000 1000",
    width: "1000pt",
    height: "1000pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.163aa06e.svg";
export { ForwardRef as ReactComponent };